mutation CreateContract($input: CreateContractInput!) {
  createContract(input: $input) {
    id
    title
    status
  }
}
